import {ImageVM} from "./ImageVM.model";
import {PriceInfoDetailVM} from "./PriceInfoDetailVM.model";
import {ServiceOptionVM} from "./ServiceOptionVM.model";
import {TotalPriceVM} from "./TotalPriceVM.model";
import {PersonInfoVM} from "./PersonInfoVM.model";
import {OrderBagItemVM} from "./OrderBagItemVM.model";
/**
 * Created by majid on 2020/05/16.
 */

export class MeetingVM {
  id:number;
  meetingId:string;
  meetingName:string;
  moderatorPW:string;
  attendeePW:string;
  maxParticipant:number;
  duration:number;
  orderBagItemId:number;
  password:string;
  fullName:string;

  constructor() {

  }

}
export enum MeetUserType
{
  MODERATOR,ATTENDEE
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/MeetingVM.model.ts